import { Components, Theme } from '@mui/joy';

export const JoyInputConfig: Partial<Components<Theme>> = {
  JoyInput: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        return {
          ...(!ownerState.error && {
            borderColor: theme.palette.neutral[300],
          }),
          backgroundColor: theme.palette.common.white,
          boxShadow: 'none',
          borderRadius: '4px',
          minHeight: '40px',
          color: theme.palette.neutral.outlinedColor,
          '&:hover:not(:has([readonly]))': {
            borderColor: ownerState.error ? theme.palette.danger[500] : theme.palette.primary[500],
          },
        };
      },
    },
    defaultProps: {},
  },
};
